<template>
  <div class="pb-32">
    <DataFetcher
      dataKey="coupons"
      ignoreUserIdQuery
      @fetched="initSlider"
      :emptyChecker="
        (data) =>
          (!Array.isArray(data) && !Array.isArray(data?.result)) ||
          (!data.length && !data?.result?.length)
      "
    >
      <template #default="{ loading, loadingError, refresh, data }">
        <div class="flex flex-col px-6 gap-8 overflow-hidden">
          <div
            v-for="(coupon, i) in loading
              ? shimmers()
              : filterValidCoupons(
                  Array.isArray(data?.result)
                    ? data.result
                    : Array.isArray(data)
                      ? data
                      : []
                )"
            :key="i"
            v-show="!isCouponApplied(coupon?.id)"
            class="w-full p-[25%] relative"
          >
            <div class="absolute w-full h-full top-0 left-0">
              <CouponItem
                :item="{
                  ...coupon,
                  color:
                    coupon.color || couponsColors[i % couponsColors.length],
                  templateKey:
                    coupon.templateKey || templateKeys[i % templateKeys.length],
                  title: coupon.title || 'Réduction Spéciale',
                  description:
                    coupon.description ||
                    'Utilisez ce code pour bénéficier de votre réduction',
                  image:
                    coupon.image || templateImages[i % templateImages.length]
                }"
              />
            </div>
          </div>
        </div>
      </template>
      <template #empty="{ refresh }">
        <SectionEmptyState
          title="De bonnes réductions vous attendent ici"
          description="Revenez bientôt pour profiter de réductions exclusives !"
          icon-type="deals"
          @refresh="refresh"
        />
      </template>
      <template #error="{ refresh }">
        <SectionEmptyState
          title="De bonnes réductions vous attendent ici"
          description="Revenez bientôt pour profiter de réductions exclusives !"
          icon-type="deals"
          @refresh="refresh"
        />
      </template>
    </DataFetcher>
    <div class="py-2"></div>
  </div>
</template>

<script setup>
import CouponItem from './CouponItem.vue';
import cartUtils from '@features/shared/libraries/cartUtils';

const shimmers = () => [
  { shimmer: true },
  { shimmer: true },
  { shimmer: true }
];
const couponsColors = ['#FF7200', 'red', '#00BE6F', 'green'];
const templateKeys = [1, 2];
const templateImages = [
  '/images/coupons/giftWhite.png',
  '/images/coupons/giftBlack.png',
  '/images/coupons/giftBlue.png'
];

const filterValidCoupons = (list) => {
  if (!Array.isArray(list)) return [];
  const now = Date.now();
  return list.filter((c) => {
    if (c?.active === false) return false;
    if (c?.validTo && new Date(c.validTo).getTime() < now) return false;
    return true;
  });
};

const initSlider = (data) => {
  console.log('Coupons loaded:', data);
};

const isCouponApplied = (couponId) => {
  const appliedPromo = cartUtils.getCart()?.promoCode;
  return appliedPromo?.id === couponId;
};
</script>
